<script setup>
import { ref, onMounted } from 'vue'
import { retrieve_child, get_report_stats, retrieve_child_meta, show_trait_count } from '@/services/child';
import { useRoute } from 'vue-router';
import DonwloadReport from './download_report.vue'
import { swalError } from '@/helper';
import { get_package, get_characteristics } from '@/services/packages';
import { update_report_stats } from '@/services/assessment';
import loadingCard from '@/components/loading.vue'
import EmptyCard from '@/components/emptyCard.vue';
import { get_term } from '@/services/term';
import childCard from './components/child_card.vue';
import subscriptionCard from './components/subscriptionCard.vue';
const route = useRoute();

const child = ref({})
const reports = ref([])

const isLoading = ref(true)
const packagesOption = ref([])
const isReportOnly = ref(false)
const page_title = ref('Child Profile')
onMounted(async()=>{
  isReportOnly.value = route.query.report_only || false
  if (!isReportOnly.value){
    page_title.value = 'Trait Selection for Assessment'
  }
  // updated api 
  let package_response = await get_package();
  if (package_response.error){
    swalError('An error occur')
  }else{
    packagesOption.value = await parsePackage(package_response.result)
    reports.value = packagesOption.value.map(item => {
      return {
        package_config: item,
        temp_sample_id: null,
        has_intervention: null,
        showSampleInput: null,
        selectedTrait: []
      }
    })
  }

  let response = await retrieve_child(route.params.id)
  child.value = response.result.data.data
  let report_relationship = response.result.data.included.filter(item=> item.type == 'report')
  reports.value = await Promise.all(report_relationship.map( async (item) =>{
    let report = reports.value.find((report) => report.package_config.id == item.attributes.report_type)
    let report_stats_response = await get_report_stats(item.id)
    let report_stats = report_stats_response.result.data.data
    let tempSelectedTrait = report_stats
                            .filter(item => item.attributes.is_intervention)
                            .map(item=>{
                              return {
                                id: item.id,
                                is_intervention: true,
                                attributes: item.attributes
                              }
                            })
    item.attributes.status = await get_status_name(item.attributes.status)
    let selectedTraitId = tempSelectedTrait.map(item => item.id)
    return {
      ...report,
      id: item.id,
      name: item.attributes.name,
      document: item.attributes.document,
      report_type: item.attributes.report_type,
      sample_id: item.attributes.sample_id,
      stats: report_stats,
      selectedTrait: tempSelectedTrait,
      attributes: item.attributes,
      selectedTraitId
    }
  }))
  await get_extra_trait()
  isLoading.value = false
})  

async function get_status_name(term_id){
  let name = 'Error'
  if (term_id == null){
    return name = '-'
  }
  let response = await get_term(term_id)
  // console.log("🚀 ~ get_status_name ~ response:", response)
  if (!response.error){
    name = response.result.data.data.attributes.name
  }else{
    swalError('Error retrieving data')
  }
  return name
}

async function parsePackage(packages){
  const updatedPackages = await Promise.all(packages.map(async (item) => {
    const response = await get_characteristics(item.id)
    if (response.error){
      swalError(response.result.error)
      return
    }
    let parsedChar = parserCharacteristic(response.result)
    item['characters'] = parsedChar
    return item
  }))
  return updatedPackages
}

function parserCharacteristic(responseData){
  const parsedData = responseData.data.map(item => {
    const name = item.attributes.name;
    const id = item.id;
    const traits = [];
  
    // Find the related option_meta data for the current item
    const optionMetaData = item.relationships.traits.data.map(trait => {
      const traitDetails = responseData.included.find(includedItem => includedItem.id === trait.id);
  
      if (traitDetails) {
        let temp = {}
        temp['name'] = traitDetails.attributes.name
        temp['id'] = traitDetails.id
        traits.push(temp)
      }
  
      return traitDetails;
    });
  
    return { id, name, traits };
  });
  return parsedData
}

function isTraitAssign(trait_id, stats){
  return stats.some((trait)=>trait_id == trait.attributes.trait_id)
}

function getTraitValue(trait_id, stats){
  return stats.find((trait)=>trait_id == trait.attributes.trait_id).attributes.score
}

function clickTraitCheckbox(report_meta_trait_id, has_intervention, report){
  const selectedTrait = report.selectedTraitId
  let trait_id = getTraitObj(report_meta_trait_id, report)
  const left_trait_count = interventionLeft(report)
  if (!report.has_intervention){ 
    return // return if its already check intervention in previous selection
  }
  const exists = Object.values(selectedTrait).includes(trait_id);
  if (exists){ // when user try to uncheck - might have error
    if(has_intervention){
      document.getElementById(report_meta_trait_id).click()
    }else{
      swalError('Could not revert the previous action')
    }
  }else{ // need to check count before selecting
    if (left_trait_count == 0){
      Swal.fire({
        title: 'Error',
        text: 'Max selected trait number reached',
        icon: 'error'
      })
    }else{
      if(has_intervention){
        document.getElementById(report_meta_trait_id).click()
      }
    }
  }
}

const isConfirming = ref(false)
async function confirmIntervention(report){
  isConfirming.value = true
  if (report.selectedTraitId.length !== 0){ // submit if not empty
    let x = report.selectedTraitId.map((item)=>{
      return{
        id: item,
        is_intervention: true
      }
    })
    // console.log("🚀 ~ file: single-application.vue:115 ~ confirmIntervention ~ report.selectedTrait:", report.selectedTrait)
    let response = await update_report_stats(report.id, x)
    isConfirming.value = false
    report.has_intervention = false
    // console.log("🚀 ~ confirmIntervention ~ response:", response)
    if (response.error){
      swalError(response.result)
      return
    }
    // console.log("🚀 ~ file: single-application.vue:118 ~ confirmIntervention ~ response:", response)
    report.stats = response.result.data.included
    Swal.fire({
      title: 'Updated',
      text: 'Selected Trait has been saved. Subscription has start',
      icon: 'success'
    })
    return
  }
  swalError('No trait selected for intervention')
}

function getTraitObj(trait_id, report){
  let { id } = report.stats.find( (trait) => trait_id == trait.attributes.trait_id )
  return id
}

function isIntervention(trait_id, report){
  let trait = report.stats.find( (trait) => trait_id == trait.attributes.trait_id )
  return trait?.attributes.is_intervention
}

function interventionLeft(report){
  let trait_left = (total_trait.value || 0) - calcSelectedTrait()
  console.log("🚀 ~ interventionLeft ~ total_trait.value:", total_trait.value)
  console.log("🚀 ~ interventionLeft ~ calcSelectedTrait():", calcSelectedTrait())
  return trait_left
}

function calcSelectedTrait(){
  let totalSelected = reports.value.map( item => item.selectedTraitId.length).reduce((acc, curr) => acc + curr, 0)
  return totalSelected
}

const child_meta = ref([])
const total_trait = ref(0)
async function get_trait_count(){
  let response = await show_trait_count(child.value.id)
  console.log("🚀 ~ get_trait_count ~ response:", response)
  if (response.error){
    swalError(response.result, true)
    return
  }
  total_trait.value = response.result.data
}

async function get_extra_trait(){
  await get_trait_count()
  let response = await retrieve_child_meta(child.value.id)
  if(response.error){
    swalError(response.result, true)
    return
  }
  child_meta.value = response.result.data.data
  let extra_trait = child_meta.value.find(item => item.attributes.key == "extra_trait")
  total_trait.value = total_trait.value + (parseInt(extra_trait?.attributes?.value) || 0)
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs :main="page_title"/>
    
    <loadingCard v-if="isLoading" />
    
    <div v-else>
      <div class="row" v-if="isReportOnly">
        <!-- Info -->
        <div class="col-md-6">
          <childCard :child="child" />
          <subscriptionCard :child_id="child.id" />
        </div>
        
        <!-- Report -->
        <div class="col-md-6">
          <DonwloadReport v-model:reports="reports"/>
        </div>
      </div>
      
      <!-- report summary -->
      <div class="row">
        <!-- title -->
        <div>
          <h5>
            {{ isReportOnly ? 'Profiling Report Summary' : ''}}
            
          </h5>
        </div>
        
        <!-- content -->
        <div class="row pe-0">
          <div class="col-12 pe-0">
            <template v-for="report in reports">
              <div v-if="report.stats.length !== 0" class="card">
                <!-- Character -->
                <div class="card-header">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h5>{{ report.package_config.options.name.value }}</h5>
                    </div>
                    <div v-if="!isReportOnly">
                      <button v-if="!report.has_intervention" class="btn btn-light-primary"
                        @click="report.has_intervention = !report.has_intervention"
                        :disabled="interventionLeft(report) > 0 ? false : true"
                      >
                        Select Trait
                        <span>
                          ({{ interventionLeft(report) }})
                        </span>
                      </button>
                      <template v-else>
                        <button class="btn btn-light-primary me-2"
                          @click="confirmIntervention(report)"
                        >
                          <div v-if="!isConfirming">
                            Confirm Trait
                            <span>
                              ({{ interventionLeft(report) }})
                            </span>
                          </div>
                          <div v-else>
                            <div class="spinner-border spinner-border-sm" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </button>
                        <button class="btn btn-light-danger"
                          @click="report.has_intervention = !report.has_intervention"
                        >
                          Cancel
                        </button>
                      </template>
                    </div>
                  </div>
                </div>

                <!-- Traits -->
                <div class="card-body row">
                  <div v-for="character in report.package_config.characters" class="col-md-6">
                    <div v-if="character.traits.length !== 0" class="card shadow-none border">
                      <div class="card-body">
                        <h5 class="ps-3">{{ character.name }}</h5>
                        <div class="list-group list-group-flush">
                          <!-- Trait Header -->
                          <div class="row px-3">
                            <div class="col-8 d-flex align-items-center mt-2 fw-medium" >
                              Trait Name
                            </div>
                            <div class="fw-medium col-4 d-flex align-items-center justify-content-center" >
                              Intensity
                            </div>
                          </div>
                          <template
                            v-for="trait in character.traits"
                            :key="trait.id"
                          >
                            <div v-auto-animate class="list-group-item list-group-item-action" 
                              v-if="isTraitAssign(trait.id, report.stats)"
                            >
                              <router-link v-if="!report.has_intervention && isIntervention(trait.id, report)"
                                class="w-100 h-100 position-absolute z-1"
                                :to="{
                                  name: 'report-home', 
                                  params: {child_id: child.id, trait_id: trait.id}
                                }"
                              ></router-link>
                              <div v-auto-animate class="row py-1">
                                <div :class="{'col-2': report.has_intervention, 'd-none': !report.has_intervention}"
                                  class="d-flex align-items-center"
                                >
                                  <button class="cover-up-checkbox" @click="clickTraitCheckbox(trait.id, report.has_intervention, report)"></button>
                                  <div class="round">
                                    <input type="checkbox" 
                                      :id="trait.id"
                                      :value="getTraitObj(trait.id, report)" 
                                      v-model="report.selectedTraitId"
                                      :disabled="isIntervention(trait.id, report)"
                                    />
                                    <label :for="trait.id"></label>
                                  </div>
                                </div>
                                <!-- Trait Name -->
                                <div :class="{'col-8' : !report.has_intervention, 'col-6' : report.has_intervention}"
                                  class="d-flex align-items-center mt-2"
                                  @click="clickTraitCheckbox(trait.id, report.has_intervention, report)"
                                >
                                  <template v-if="!isReportOnly">
                                    <div class="intervention-tag me-2" 
                                      v-if="!report.has_intervention && isIntervention(trait.id, report)"
                                    >
                                      <vue-feather class="m-auto" size="1rem" type="activity"></vue-feather>
                                    </div>
                                  </template>
                                  {{ trait.name }}
                                </div>
                                <!-- Trait Score -->
                                <div class="col-4 d-flex align-items-center justify-content-center"
                                  @click="clickTraitCheckbox(trait.id, report.has_intervention, report)"
                                >
                                  {{ getTraitValue(trait.id, report.stats) }} / 
                                  {{ report.package_config.options.max?.value  || '' }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>